<template>
  <v-app>
    <v-app-bar
      app
    >
        Samuli Virtapohja
        <v-spacer></v-spacer>
        <v-btn
          icon
          href='https://www.linkedin.com/in/samuli-virtapohja-58a91ba2/'
          target="_blank">
          <v-icon
            large>
            mdi-linkedin
          </v-icon>
        </v-btn>
        <v-btn
          icon
          href='https://github.com/SamuliVirtapohja'
          target="_blank">
          <v-icon
            large>
            mdi-github
          </v-icon>
        </v-btn>
        <v-btn
          icon
          href='https://gitlab.labranet.jamk.fi/L4721'
          target="_blank">
          <v-icon
            large>
            mdi-gitlab
          </v-icon>
        </v-btn>
    </v-app-bar>

    <v-main>
      <Introduction />
      <ProjectList />
    </v-main>
  </v-app>
</template>

<script>
import Introduction from '@/components/Introduction.vue'
import ProjectList from '@/components/ProjectList.vue'

export default {
  name: 'App',

  components: {
    Introduction,
    ProjectList,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #121212 #272727;
}

/* Chrome */
*::-webkit-scrollbar {
  width: 6px;
}
*::-webkit-scrollbar-track {
  background: #272727;
}
*::-webkit-scrollbar-thumb {
  background-color: #121212;
  border-radius: 20px;
  border: 3px solid #121212;
}

body {
  background-color: #121212;
}
</style>
